import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPaymentError = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#FEDDDD"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="#fff"
        d="M11.375 30.493c0-6.655 0-9.983 2.068-12.05s5.394-2.068 12.05-2.068h11.764c6.655 0 9.983 0 12.05 2.067s2.068 5.395 2.068 12.05 0 9.983-2.068 12.05-5.395 2.068-12.05 2.068H25.493c-6.655 0-9.983 0-12.05-2.067s-2.068-5.395-2.068-12.05"
      />
      <path
        fill="currentColor"
        d="M50 30.492c0-3.366-.003-5.752-.246-7.561-.238-1.77-.683-2.78-1.419-3.516s-1.746-1.181-3.516-1.419c-1.809-.243-4.195-.246-7.561-.246H25.492c-3.366 0-5.752.003-7.561.246-1.77.238-2.78.683-3.516 1.419s-1.181 1.746-1.419 3.516c-.243 1.809-.246 4.195-.246 7.561s.003 5.753.246 7.563c.238 1.77.683 2.78 1.419 3.515s1.746 1.181 3.516 1.42c1.809.242 4.195.245 7.561.245h11.766c3.366 0 5.752-.002 7.561-.246 1.77-.238 2.78-.683 3.516-1.419.736-.735 1.181-1.746 1.419-3.515.243-1.81.246-4.196.246-7.563m2.75 0c0 3.289.003 5.894-.27 7.929-.28 2.075-.869 3.762-2.2 5.094-1.333 1.331-3.02 1.92-5.095 2.2-2.034.273-4.639.27-7.927.27H25.492c-3.288 0-5.893.003-7.928-.27-2.074-.28-3.762-.869-5.094-2.2s-1.92-3.02-2.2-5.094c-.273-2.035-.27-4.64-.27-7.929 0-3.288-.003-5.893.27-7.928.28-2.074.868-3.762 2.2-5.094s3.02-1.92 5.094-2.2c2.035-.273 4.64-.27 7.928-.27h11.766c3.288 0 5.893-.003 7.927.27 2.075.28 3.763.868 5.094 2.2s1.922 3.02 2.2 5.095c.274 2.034.271 4.639.271 7.927"
      />
      <path
        fill="#fff"
        d="M37.257 30.493a5.882 5.882 0 1 1-11.764 0 5.882 5.882 0 0 1 11.764 0"
      />
      <path
        fill="currentColor"
        d="M35.882 30.493a4.508 4.508 0 1 0-9.015 0 4.508 4.508 0 0 0 9.015 0m2.75 0a7.257 7.257 0 1 1-14.514 0 7.257 7.257 0 0 1 14.514 0"
      />
      <path fill="#fff" d="M44.316 35.199v-9.412zm-25.882 0v-9.412z" />
      <path
        fill="currentColor"
        d="M17.059 35.199v-9.412a1.375 1.375 0 1 1 2.75 0v9.412a1.375 1.375 0 0 1-2.75 0m25.883 0v-9.412a1.375 1.375 0 1 1 2.75 0v9.412a1.376 1.376 0 0 1-2.75 0"
      />
      <path
        fill="#BB110E"
        d="M58.375 39.375c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11"
      />
      <path
        fill="#fff"
        d="M50.263 34.93a1.1 1.1 0 0 1 1.557 1.555l-2.89 2.889 2.89 2.89a1.1 1.1 0 0 1-1.557 1.556l-2.89-2.89-2.888 2.89a1.1 1.1 0 0 1-1.554-1.557l2.888-2.89-2.889-2.888a1.1 1.1 0 1 1 1.555-1.554l2.889 2.888z"
      />
    </svg>
  );
};
export default SvgPaymentError;
